import { Component } from '@angular/core';
@Component({
    templateUrl: './unsubscribe.component.html'
})
export class UnsubscribeComponent {
}


// WEBPACK FOOTER //
// ./src/app/clients/auth/unsubscribe/unsubscribe.component.ts